import clsx from 'clsx'

/**
 * Keep copy in sync with the shareable HTML report explainer in
 * apps/worker/src/routes/reports.ts (`generateReportHTML`).
 */
export function EngagementScoreExplainer({ className }: { className?: string }) {
  return (
    <details className={clsx('group', className)}>
      <summary className="text-xs text-brand-teal font-medium cursor-pointer list-none underline underline-offset-2 hover:text-brand-teal-hover [&::-webkit-details-marker]:hidden">
        <span className="inline">How is this different from “% of nudges acted on”?</span>
      </summary>
      <div className="mt-2 text-xs text-ink-muted leading-relaxed max-w-2xl space-y-2 pl-0 border-l-2 border-warm-border pl-3">
        <p>
          <strong className="text-ink">Engagement score</strong> is a blended 0–100 index. It combines several signals—such
          as opens, actions, how many people are receiving nudges, and whether people are acting across multiple
          days—not a single raw percentage.
        </p>
        <p>
          <strong className="text-ink">Action %</strong> (and similar rates on Analytics or in shared reports) is
          simpler: it is the straight share of <em>delivered</em> nudges that had an action recorded over the time
          period shown.
        </p>
      </div>
    </details>
  )
}
